/**
 * Export data to CSV with proper UTF-8 encoding (compatible Excel France)
 * Uses semicolon separator for French locale
 */
export const exportToCSV = (data, filename) => {
  if (!data || data.length === 0) return;

  const cleanValue = (val) => {
    if (val === null || val === undefined) return '';
    const str = String(val);
    if (str.includes(';') || str.includes('\n') || str.includes('"')) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const headers = Object.keys(data[0]);
  const csvRows = [
    headers.map(cleanValue).join(';'),
    ...data.map(row => headers.map(h => cleanValue(row[h])).join(';'))
  ];

  const BOM = '\uFEFF'; // Excel UTF-8 BOM
  const csvContent = BOM + csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Contacts export fields
export const exportContacts = (contacts) => {
  const data = contacts.map(c => ({
    'Prénom': c.first_name || '',
    'Nom': c.last_name || '',
    'Email': c.email || '',
    'Téléphone': c.phone || '',
    'Entreprise': c.company_name || '',
    'Notes': c.notes || '',
    'Responsable': c.owner_name || '',
    'Date création': c.created_at ? c.created_at.substring(0, 10) : '',
  }));
  exportToCSV(data, `contacts_export_${new Date().toISOString().substring(0,10)}.csv`);
};

// Companies export fields
export const exportCompanies = (companies) => {
  const data = companies.map(c => ({
    'Nom': c.name || '',
    'Secteur': c.industry || '',
    'Taille': c.size || '',
    'Email': c.email || '',
    'Téléphone': c.phone || '',
    'Site web': c.website || '',
    'Adresse': c.address || '',
    'Notes': c.notes || '',
    'Responsable': c.owner_name || '',
    'Date création': c.created_at ? c.created_at.substring(0, 10) : '',
  }));
  exportToCSV(data, `entreprises_export_${new Date().toISOString().substring(0,10)}.csv`);
};

// Devis export fields
export const exportDevis = (deals) => {
  const stageLabels = { lead: 'Lead/Prospect', qualified: 'Qualifié', proposal: 'Proposition', negotiation: 'Négociation', won: 'Gagné', lost: 'Perdu' };
  const data = deals.map(d => ({
    'Titre': d.title || '',
    'Valeur (€)': d.value || 0,
    'Devise': d.currency || 'EUR',
    'Étape': stageLabels[d.stage] || d.stage || '',
    'Probabilité (%)': d.probability || 0,
    'Contact': d.contact_name || '',
    'Entreprise': d.company_name || '',
    'Date de clôture': d.expected_close_date || '',
    'Responsable': d.owner_name || '',
    'Notes': d.notes || '',
    'Date création': d.created_at ? d.created_at.substring(0, 10) : '',
  }));
  exportToCSV(data, `devis_export_${new Date().toISOString().substring(0,10)}.csv`);
};

// Activities export fields
export const exportActivities = (activities) => {
  const typeLabels = { call: 'Appel', email: 'Email', meeting: 'Réunion', task: 'Tâche', note: 'Note' };
  const data = activities.map(a => ({
    'Type': typeLabels[a.type] || a.type || '',
    'Titre': a.title || '',
    'Description': a.description || '',
    'Devis associé': a.deal_title || '',
    'Contact': a.contact_name || '',
    'Responsable': a.owner_name || '',
    'Date échéance': a.due_date || '',
    'Statut': a.completed ? 'Complétée' : 'En attente',
    'Date création': a.created_at ? a.created_at.substring(0, 10) : '',
  }));
  exportToCSV(data, `activites_export_${new Date().toISOString().substring(0,10)}.csv`);
};
